import styled, { keyframes } from 'styled-components';

const countEnterKeyframes = keyframes`
	0% {
		transform: translate(-50%, -200%);
		left: 50%;
		opacity: 0;
	}
	50% {
		transform: translate(-50%, 0);
		left: 50%;
		opacity: 1;
	}
	100% {
		transform: translate(0, 0);
		left: 0;
		opacity: 1;
	}
`;

const moneyEnterKeyframes = keyframes`
	0% {
		opacity: 0;
		transform: translateX(-10px);
	}
	100% {
		opacity: 1;
		transform: translateX(0);
	}
`;

const exitKeyframes = keyframes`
	0% {
		transform: translateY(0);
		opacity: 1;
	}
	100% {
		transform: translateY(-200%);
		opacity: 0;
	}
`;

const StyledContainer = styled.div`
	position: relative;
	display: flex;
	width: 0;
	gap: 10px;
	transition:
		transform 0.3s ease,
		width 3.3s ease;

	&.progress-enter-active,
	&.progress-enter-done {
		width: 100%;
		.count {
			animation-name: ${countEnterKeyframes};
			animation-duration: 0.5s;
			animation-timing-function: ease;
			animation-iteration-count: 1;
			animation-direction: normal;
			animation-fill-mode: forwards;
		}

		.money {
			animation-name: ${moneyEnterKeyframes};
			animation-duration: 0.75s;
			animation-timing-function: ease;
			animation-iteration-count: 1;
			animation-direction: normal;
			animation-delay: 0.5s;
			animation-fill-mode: forwards;
		}
	}

	&.progress-exit-active {
		width: 0;
		.count,
		.money {
			animation-name: ${exitKeyframes};
			animation-duration: 0.5s;
			animation-timing-function: ease;
			animation-iteration-count: 1;
		}
	}
`;

const StyledBlock = styled.div`
	display: grid;
	grid-template-columns: 16px 1px auto;
	align-items: center;
	gap: 10px;
	height: 30px;
	padding: 0 10px;
	border-radius: 10px;
	background-color: #ffffff;

	img {
		width: 16px;
		height: 16px;
		user-select: none;
		pointer-events: none;
	}

	.invert {
		filter: invert(100%);
	}

	.line {
		width: 1px;
		height: 100%;
		background-color: rgba(0, 0, 0, 0.1);
	}
`;

const StyledCountContainer = styled(StyledBlock)`
	transform: translateY(-200%);
	opacity: 0;
`;

const StyledMoneyContainer = styled(StyledBlock)`
	opacity: 0;
	transform: translateX(-100%);
`;

const StyledText = styled.p`
	font-family: 'GT Walsheim Pro';
	font-style: normal;
	font-weight: 500;
	font-size: 14px;
	line-height: 16px;
	color: #000000;
	white-space: nowrap;
`;

export {
	StyledContainer,
	StyledCountContainer,
	StyledMoneyContainer,
	StyledText,
};
